import { sortAlphabetically } from './sortAlphabetically';
import { sortNumerically } from './sortNumerically';
import { getSorter } from './getSorter';

/**
 * Resolves the sorter function to use for the column
 * The sortableDetails are checked first for a value.  It looks on the sortable details for a column specific
 * sorter or a default sorter
 * @param sortableDetails
 * @param column
 * @param data
 */
export const resolveSorter = (sortableDetails, column, data) => {
  const sorter = sortableDetails?.sorter?.[column.dataIndex];
  const defaultSorter = sortableDetails?.sorter?.default;
  const effectiveSorter = sorter || defaultSorter;
  if (typeof effectiveSorter === 'string') {
    return effectiveSorter === 'numeric' ? sortNumerically(column) : sortAlphabetically(column);
  } else if (typeof effectiveSorter === 'function') {
    return effectiveSorter;
  }
  return getSorter(data, column);
};